<template>
    <div class="flex-container">
        <!-- <div v-for="item in artists"  :key="item.artists_id"> -->
           <RssFeedItem  @getrssdata="getRssData" v-for="item in artists"  :key="item.artists_id" :artist="item"></RssFeedItem>
        <!-- </div> -->
        <!-- <div  class="row-item">
            FEED !
        </div>
        <div  class="row-item">
            FEED !
        </div>
        <div  class="row-item">
            FEED !
        </div> -->
    </div>
</template>
<script>
import RssFeedItem from "./rss-feed-item.vue"
export default {
  components: {
      RssFeedItem
  },
  props:["artists"],
  methods:{
      getRssData(artists_id){
          this.$emit("getrssdata",artists_id)
      }
  }  
}
</script>
<style scoped>
    .flex-container
    {
        display: flex;
        flex-direction: column;
    }
    .row-item
    {
        padding:8px;
        border-bottom:1px solid #ccc;
        cursor: pointer;
    }
</style>